export default [
    'GetQuestionById',// 请求题目信息
    "GetQuestionInfo",// 获取单个题目信息
    "SetCourseTestCaseOpenClass",
    'GetPopulationStatisticsInfo',
    'GetTestCaseList',
    'GetCourseTestCaseList',
    'SubmitExam',
];


// WEBPACK FOOTER //
// ./src/constants/apiContext.js